var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"route-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu4-3'),"subtitle":"Service Cargo"}}),_c('div',{staticClass:"layout-width layout-r",attrs:{"id":"articlek"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }